import {Component, EventEmitter, Input, OnChanges, Output, SimpleChange} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ClassificationGroup } from "../../../../../../../models/classification-group";
import { FieldType } from "../../../../../../../models/field-type";
import { Guide } from "../../../../../../../models/guide";
import { ClassificationControllerService } from "../../../../../../../services/classifications-controller/classification-controller.service";
import { ClassificationGroupControllerService } from "../../../../../../../services/classifications-controller/classification-group-controller.service";
import FormUtils from "../../../../../../utils/form-utils.component";
import { BaseError } from "../../../../../base-error";

@Component({
    selector: "field-set-guide-classification",
    templateUrl: "./field-set-guide-classification.component.html",
    styles: [],
})
export class FieldSetGuideClassificationComponent extends BaseError implements OnChanges {

    @Input() public fieldOptions: any;
    @Input() public classificationsList: any[];
    @Input() public guides: any[];
    @Input() public guide: Guide;
    @Output() public dataChanged = new EventEmitter();
    public classificationFields: any[] = [];
    public catalogGroups: ClassificationGroup[] = [];

    constructor(public toastr: ToastrService,
                private classificationControllerService: ClassificationControllerService,
                private classificationGroupService: ClassificationGroupControllerService) {
        super(toastr);
    }

    public ngOnChanges(_changes: { [propKey: string]: SimpleChange }) {
        this.mapClassificationFields();
        this.loadCatalogGroups();
    }

    public selectedParent(parent) {
        const found = this.guides.find((it) => it.id === parent);
        if (found) {
            this.guide.parentQuestionId = found.id;
            this.fieldOptions.parentClassificationFieldKey = FormUtils.generateGuideIdFromTitle(found.title);
        }
    }

    public mapClassificationFields() {
        if (this.guides) {
            this.classificationFields = [];
            this.guides.map((item) => {
                if (item.type === FieldType.CLASSIFICATION && item.id !== this.guide.id) {
                    this.classificationFields.push(item);
                }
            });
        }
    }

    public classificationChanged(classificationId) {
        const foundClassification = this.classificationsList.find((it) => it.id === classificationId);
        if (foundClassification) {
            this.guide.classification = foundClassification;
            this.loadCatalogGroups();
        }
        this.dataChanged.emit(classificationId);
    }

    public groupChanged(groupId: string) {
        this.guide.catalogGroupId = groupId;
    }

    public loadCatalogGroups() {
        if (this.guide && this.guide.classification && this.guide.classification.id) {
            this.classificationGroupService.getClassificationsGroupsByType(this.guide.classification.id).subscribe(
                (data) => this.catalogGroups = data,
                (error) => {
                    this.catalogGroups = [];
                    this.showErrorMessageWithTitle("Error when loading catalog groups!", error);
                },
            );
        } else {
            this.catalogGroups = [];
        }
    }
}
